import { render, staticRenderFns } from "./ChildComment.vue?vue&type=template&id=28c98aff&scoped=true&"
import script from "./ChildComment.vue?vue&type=script&lang=js&"
export * from "./ChildComment.vue?vue&type=script&lang=js&"
import style0 from "./ChildComment.vue?vue&type=style&index=0&id=28c98aff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c98aff",
  null
  
)

export default component.exports